module.exports = __webpack_public_path__ + "static/media/flag-black.0536efc8.svg";